<div class="filter-component-container">

    <div class="filter-component-main container-with-select">
        <mat-form-field>
            <mat-label>Seguradoras</mat-label>
            <mat-select [(ngModel)]="seguradora">
                <mat-option *ngFor="let seguradora of seguradoras" [value]="seguradora.value"><img *ngIf="seguradora.img"
                        class="imgSeg" [ngStyle]="{'width':'40px','height':'40px', 'margin-right':'4px', 'border-radius':'50%'}"
                        [src]="seguradora.img">
                    {{ seguradora.nome }} </mat-option>
            </mat-select>
        </mat-form-field>
    
        <mat-form-field>
            <mat-label>Tipo do periodo</mat-label>
            <mat-select [(ngModel)]="tipoPeriodo" [disabled]="vencidas != 0">
                <mat-option value="E">Emissão</mat-option>
                <mat-option value="V">Fim da Vigência</mat-option>
                <mat-option value="I">Importação</mat-option>
            </mat-select>
        </mat-form-field>
    
        <mat-form-field>
            <mat-label>Periodo</mat-label>
            <mat-select [(ngModel)]="periodo" (selectionChange)="verificaPeriodo($event)" [disabled]="vencidas != 0">
                <mat-option value="I">Indefinido</mat-option>
                <mat-option value="7">Últimos 7 dias</mat-option>
                <mat-option value="15">Últimos 15 dias</mat-option>
                <mat-option value="30">Últimos 30 dias</mat-option>
                <mat-option value="p">Personalizado</mat-option>
            </mat-select>
        </mat-form-field>
    
        <form [formGroup]="fg_datas">
            <mat-form-field *ngIf="showDatas">
                <mat-label>Data Inicial</mat-label>
                <input autocomplete="off" [mask]="masks.DD_MM_AAAA" matInput inputmode="numeric" debounce-validation="500"
                    [validate-on-keydown]="true" [formControl]="fg_datas.controls.dataIni">
                <mat-icon matSuffix [svgIcon]="'calendar'"
                    (click)="openCalendar(pickerIni, fg_datas.controls.dataIni, fg_datas.controls.dataIniInv, $event)">
                </mat-icon>
                <mat-datepicker #pickerIni></mat-datepicker>
                <input [matDatepicker]="pickerIni" (dateChange)="onChange($event, fg_datas.controls.dataIni)"
                    [ngStyle]="{display: 'none'}" [formControl]="fg_datas.controls.dataIniInv">
            </mat-form-field>
    
            <mat-form-field *ngIf="showDatas">
                <mat-label>Data Final</mat-label>
                <input autocomplete="off" [mask]="masks.DD_MM_AAAA" matInput inputmode="numeric" debounce-validation="500"
                    [validate-on-keydown]="true" [formControl]="fg_datas.controls.dataFim">
                <mat-icon matSuffix [svgIcon]="'calendar'"
                    (click)="openCalendar(pickerFim, fg_datas.controls.dataFim, fg_datas.controls.dataFimInv, $event)">
                </mat-icon>
                <mat-datepicker #pickerFim></mat-datepicker>
                <input [matDatepicker]="pickerFim" (dateChange)="onChange($event, fg_datas.controls.dataFim)"
                    [ngStyle]="{display: 'none'}" [formControl]="fg_datas.controls.dataFimInv">
            </mat-form-field>
        </form>
    </div>

    <div class="filter-component-actions">
        <button class="btn-limpar-filtro" (click)="clearFilter()">Limpar Filtros</button>
        <button class="btn-filtro" (click)="buildString()">Aplicar</button>
    </div>
    
</div>